module.exports = __webpack_public_path__ + "static/media/healthcare1.a27702f4.png";